import { html, css, LitElement } from 'lit';
import { Text } from '../Text/Text';
import { Image } from '../Image/Image';
class Chip extends LitElement {
  static properties = {
    imageSrc: { type: String },
    imageAlt: { type: String },
    imageHeight: { type: String },
    imageWidth: { type: String },
    imageRadius: { type: String },
    //    image property ends here
    label: { type: String },
    labelColor: { type: String },
    labelFontFamily: { type: String },
    labelFontWeight: { type: String },
    labelFontSize: { type: String },
    labelFontStyle: { type: String },
    //    label properties ends here

    padding: { type: String },
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    height: { type: String },
    width: { type: String },
    textColor: { type: String },
  };

  static styles = css`
    .chip-container {
      display: flex;
      align-items: center;
      gap: 8px;
      border-radius: 20px;
      cursor: pointer;
    }
    .chip-close-icon {
      width: 16px;
      height: 16px;
      opacity: 0.7;
      transition: opacity 0.2s ease;
    }
    .chip-close-icon:hover {
      opacity: 1;
    }
    .chip-label-container {
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
      max-width: calc(100% - 40px);
      margin: 0 8px;
    }
    .chip-image-container {
      display: flex;
      align-items: center;
    }
  `;

  constructor() {
    super();
    this.profilePlaceholderImage = 'https://isometrik-website-bucket.s3.ap-south-1.amazonaws.com/Frame_02577f7cb1.svg';
  }

  handleImageError(e) {
    e.target.src = this.profilePlaceholderImage;
  }

  render() {
    return html`
      <div
        class="chip-container"
        style="background-color: ${this.bgColor}; border-width: ${this.borderWidth}; border-color: ${this.borderColor}; border-style: ${this.borderStyle}; height: ${this
          .height}; width: ${this.width}; color: ${this.textColor}; padding: ${this.padding}; border-radius: ${this.borderRadius || '20px'};
          padding-right: 10px;"
      >
        ${this.imageSrc
          ? html`
              <div class="chip-image-container">
                ${Image({
                  src: this.imageSrc,
                  alt: this.imageAlt,
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  placeholderImage: this.profilePlaceholderImage,
                  cursor: 'pointer',
                  objectFit: 'cover',
                })}
              </div>
            `
          : ''}
        <div class="chip-label-container">
          ${Text({
            content: this.label,
            color: this.labelColor,
            fontSize: this.labelFontSize,
            fontWeight: this.labelFontWeight,
            fontStyle: this.labelFontStyle,
            fontFamily: this.labelFontFamily,
          })}
        </div>
        <svg class="chip-close-icon" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="${this.textColor}">
          <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
        </svg>
      </div>
    `;
  }
}

customElements.define('iso-chip', Chip);
